import { useRouter } from 'next/router'
import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import AuthLayout from 'src/@core/layouts/AuthLayout'
import SetPassword from 'src/components/auth/SetPassword'
import Login from 'src/components/auth/Login'
import ResetPassword from 'src/components/auth/ResetPassword'
import SignUp from 'src/components/auth/SignUp'
import { hasAuthCookie } from 'src/lib/utils/helpers'
import EmailConfirm from 'src/components/auth/EmailConfirm'
import EmailExpired from 'src/components/auth/EmailExpired'
import VerifyEmail from 'src/components/auth/VerifyEmail'
import EmailSent from 'src/components/auth/EmailSent'
import RecipientEmailConfirmation from 'src/components/auth/InvititationAccepted'

const Auth = () => {
  const router = useRouter()
  const { type } = router.query
  const redirectType = type ? type[0] : ''

  const allowedModes = [
    'signup',
    'email-confirm',
    'email-expired',
    'login',
    'reset-password',
    'set-password',
    'email-verify',
    'email-sent',
    'join-team',
    'recipient-email-confirm'
  ]

  useEffect(() => {
    if (hasAuthCookie()) {
      redirectType === 'login' ? router.replace('/') : router.replace('/switch-store')
      return
    }
    if (Boolean(redirectType) && !Boolean(allowedModes.includes(redirectType))) {
      router.replace('/auth/login')
      return
    }
  }, [redirectType])

  const getMainContent = useCallback(() => {
    switch (redirectType) {
      case 'signup':
        return <SignUp />
      case 'email-confirm':
        return <EmailConfirm />
      case 'email-expired':
        return <EmailExpired />
      case 'login':
        return <Login />
      case 'reset-password':
        return <ResetPassword />
      case 'set-password':
      case 'join-team':
        return <SetPassword />
      case 'email-verify':
        return <VerifyEmail />
      case 'email-sent':
        return <EmailSent />
      case 'recipient-email-confirm':
        return <RecipientEmailConfirmation />
      default:
        return <></>
    }
  }, [redirectType])

  return (
    <div className={`flex flex-col items-center relative bg-[#101010] h-fit box-border `}>
      <div className=''>{getMainContent()}</div>
    </div>
  )
}

Auth.getLayout = (page: ReactNode) => <AuthLayout>{page}</AuthLayout>

export default Auth
